#import "../fragments/replyable-email.graphql"

query GetReplyableEmail($emailId: ID!) {
    replyEmail(replyEmailId: $emailId) {
        ...ReplyableEmail
    }
}
